import React from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaGlobe, FaUserCheck, FaFileAlt, FaLandmark, FaVoteYea, FaTrain, FaUniversity, FaPhone, FaEnvelope } from 'react-icons/fa';
function ImportantLinks() {
  const governmentPortals = [
    { name: 'राजस्व विभाग', description: 'महसूल विभाग सेवा', url: 'https://revenue.maharashtra.gov.in/', icon: <FaLandmark />, color: '#e74c3c' },
    { name: 'राष्ट्रीय सूचना केंद्र', description: 'National Information Center', url: 'https://www.nic.in/', icon: <FaGlobe />, color: '#3498db' },
    { name: 'माहिती अधिकार', description: 'Right to Information Portal', url: 'https://rtionline.maharashtra.gov.in/', icon: <FaFileAlt />, color: '#2ecc71' },
    { name: 'भूमि अभिलेख', description: 'जमीन नोंदी पोर्टल', url: 'https://bhulekh.mahabhumi.gov.in/', icon: <FaLandmark />, color: '#9b59b6' },
    { name: 'आपले सरकार', description: 'ऑनलाइन सरकारी सेवा', url: 'https://aaplesarkar.mahaonline.gov.in/', icon: <FaUserCheck />, color: '#138808' },
    { name: 'महाDBT', description: 'थेट लाभ हस्तांतरण', url: 'https://mahadbt.maharashtra.gov.in/', icon: <FaFileAlt />, color: '#1abc9c' },
    { name: 'महाDBT शिष्यवृत्ती', description: 'शिष्यवृत्ती पोर्टल', url: 'https://mahadbtmahait.gov.in/', icon: <FaUniversity />, color: '#f39c12' },
    { name: 'डिजिटल इंडिया', description: 'Digital India उपक्रम', url: 'https://digitalindia.gov.in/', icon: <FaGlobe />, color: '#3498db' },
    { name: 'आधार सेवा', description: 'UIDAI आधार पोर्टल', url: 'https://uidai.gov.in/', icon: <FaUserCheck />, color: '#e74c3c' },
    { name: 'भारत सरकार', description: 'Government of India Portal', url: 'https://india.gov.in/', icon: <FaLandmark />, color: '#2c3e50' },
    { name: 'निवडणूक आयोग', description: 'Election Commission of India', url: 'https://eci.gov.in/', icon: <FaVoteYea />, color: '#9b59b6' },
    { name: 'IRCTC रेल्वे', description: 'रेल्वे तिकीट बुकिंग', url: 'https://www.irctc.co.in/', icon: <FaTrain />, color: '#1abc9c' },
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section
        className="hero"
        style={{ height: '45vh', background: 'linear-gradient(135deg, #138808 0%, #2e7d32 100%)' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <motion.h1 className="page-hero-title" initial={{ y: -30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }}>
            महत्त्वाचे दुवे व सेवा
          </motion.h1>
          <motion.p className="page-hero-sub" initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.4 }}>
            सरकारी पोर्टल्स आणि ऑनलाइन सेवांचा एकत्रित संग्रह
          </motion.p>
        </div>
      </motion.section>

      <section className="services-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #138808, #2e7d32)',
              color: 'white',
              padding: '2rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginBottom: '3rem',
              boxShadow: '0 10px 30px rgba(19,136,8,0.3)'
            }}
          >
            <h2 style={{ marginBottom: '0.8rem', fontSize: '1.8rem' }}>सरकारी पोर्टल्स व सेवा</h2>
            <p style={{ fontSize: '1rem', opacity: 0.9 }}>एकाच ठिकाणाहून सर्व महत्वाच्या सरकारी वेबसाइट्स आणि ऑनलाइन सेवा मिळवा</p>
          </motion.div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
            {governmentPortals.map((portal, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                style={{
                  background: 'white',
                  padding: '1.8rem',
                  borderRadius: '14px',
                  boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                  border: `2px solid ${portal.color}20`,
                  cursor: 'pointer'
                }}
                whileHover={{ scale: 1.03, boxShadow: '0 12px 35px rgba(0,0,0,0.15)', borderColor: portal.color }}
                onClick={() => window.open(portal.url, '_blank')}
              >
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                  <div style={{
                    fontSize: '1.8rem', color: portal.color, marginRight: '1rem',
                    background: `${portal.color}15`, padding: '0.8rem', borderRadius: '12px', flexShrink: 0
                  }}>
                    {portal.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ color: '#2c3e50', fontSize: '1.1rem', margin: 0, marginBottom: '0.2rem', fontWeight: '700' }}>{portal.name}</h3>
                    <p style={{ color: '#888', fontSize: '0.85rem', margin: 0 }}>{portal.description}</p>
                  </div>
                  <FaExternalLinkAlt style={{ color: portal.color, fontSize: '1rem', flexShrink: 0 }} />
                </div>
                <div style={{ background: `${portal.color}10`, padding: '0.6rem 0.8rem', borderRadius: '8px', fontSize: '0.8rem', color: '#666', wordBreak: 'break-all' }}>
                  🔗 {portal.url}
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #2c3e50, #34495e)',
              color: 'white', padding: '2.5rem', borderRadius: '15px',
              textAlign: 'center', marginTop: '3rem',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
            }}
          >
            <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>मदत हवी आहे का?</h3>
            <p style={{ fontSize: '1rem', lineHeight: '1.8', marginBottom: '1.5rem', opacity: 0.9 }}>
              सरकारी सेवांसाठी कोणत्याही मदतीसाठी आपल्या स्थानिक ग्रामपंचायत कार्यालयाशी संपर्क साधा
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaEnvelope style={{ color: '#66bb6a' }} />
                <span>gpnasherapsmokhada@gmail.com</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaPhone style={{ color: '#66bb6a' }} />
                <span>+91 7620 135 257</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default ImportantLinks;
